import { Mail, Phone, MapPin } from "lucide-react";

interface OfficeCardProps {
  type: string;
  title: string;
  description: string;
  email: string;
  phone: string;
  location: string;
}

export function OfficeCard({
  type,
  title,
  description,
  email,
  phone,
  location,
}: OfficeCardProps) {
  return (
    <div className="flex flex-col gap-4 p-4 md:p-5 lg:p-6 border border-gray-200 bg-white flex-1 shadow-lg">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1.5">
          <p className="text-primary text-sm font-medium tracking-tight">{type}</p>
          <h3 className="text-slate-900 text-lg md:text-xl font-semibold leading-[150%]">{title}</h3>
        </div>
        <p className="text-slate-600 text-sm font-medium leading-[150%] tracking-tight">{description}</p>
      </div>
      
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-200-[20px]">
          <Mail className="w-4 h-4 text-primary flex-shrink-0" />
          <span className="text-slate-700 text-xs sm:text-sm font-medium leading-[150%]">{email}</span>
        </div>
        
        <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-200-[20px]">
          <Phone className="w-4 h-4 text-primary flex-shrink-0" />
          <span className="text-slate-700 text-xs sm:text-sm font-medium leading-[150%]">{phone}</span>
        </div>
        
        <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-200-[20px]">
          <MapPin className="w-4 h-4 text-primary flex-shrink-0" />
          <span className="text-slate-700 text-xs sm:text-sm font-medium leading-[150%]">{location}</span>
        </div>
      </div>
      
      <button className="w-full px-4 py-3 bg-primary hover:bg-primary/90 text-white text-sm font-medium leading-[131%] tracking-tight transition-colors">
        Get Direction
      </button>
    </div>
  );
}

